// extracted by mini-css-extract-plugin
export default {"list":"AccionaUploadModal_list__3brSE"};